import React from "react";
import './SideBar.scss';
import {toggleClass} from "../../common";

export default function SideBar(props) {
    function openDropDown(e) {
        console.log(e.target);
        let element = e.target.nextElementSibling;
        toggleClass(element,'show');
        toggleClass(e.target,'collapsed')
    }
    return (
        <div className="main-sidebar">
            <div className="navbar-list">
                <ul>
                    <li className="navItems active" data-subsection="false" data-id="0">
                        <span className="section-icon"></span><span
                        className="title">Home</span></li>
                    <li className="navItems" data-subsection="true" data-id="1">
                        <span className="section-icon"></span><span
                        className="title">Customization</span></li>
                    <li className="navItems" data-subsection="false" data-id="3">
                        <span className="section-icon"></span><span
                        className="title">Realtime</span></li>
                    <li className="navItems" data-subsection="false" data-id="12">
                        <span className="section-icon"></span><span className="title">Audience</span>
                    </li>
                    <li className="navItems" data-subsection="false" data-id="34221">
                        <span className="section-icon"></span><span className="title">Acquisation</span>
                    </li>
                    <li className="navItems" data-subsection="true" data-id="38">
                        <span className="section-icon"></span><span
                        className="title">Behaviour</span></li>
                    <li className="navItems" data-subsection="false" data-id="13">
                        <span className="section-icon"></span><span className="title">Conversion</span>
                    </li>
                    <li className="navItems" data-subsection="true" data-id="33322">
                        <span className="section-icon"></span><span
                        className="title">Admin</span></li>
                </ul>
            </div>
        </div>
    )

}